<template>
  <div class="onetrust-blocker">
    <div class="onetrust-blocker__block">
      <h3>
        {{ settings.message }}
      </h3>
      <div>
        <button ref="button" @click="onClick">{{ settings.button }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'onetrust-blocker',
  props: {
    requiredCookie: {
      type: String,
      default: null
    }
  },
  watch: {
    consented() {
      const { button } = this.$refs
      button.innerText = this.settings.button
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'settings',
      'consented'
    ]),
  },
  methods: {
    onClick() {
      window.OneTrust.ToggleInfoDisplay()
    }
  }
}
</script>

<style lang="scss" scoped>

.onetrust-blocker {
  background: #FFF;
  height: 100%;
  
  &__block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px;
    height: 100%;

    & h3 {
      margin-bottom: 15px;
      font-weight: normal;
      max-width: 600px;
      text-align: center;
    }

    & button {
      display: inline-block;
      color: #1d2822;
      border-radius: 40px;
      padding: 1em 2em;
      font-size: 1em;
      line-height: 1em;
      font-weight: 600;
      letter-spacing: -1px;
      text-align: center;
      transition: all .35s ease;
      background-color: #9ddda9;
      text-decoration: none;
    }
  }
}

</style>
